// Do not delete this Chart import line
import {Chart as ChartJS} from "chart.js/auto";
import {Line} from "react-chartjs-2";

const MeasurementsChart = ({data}) => {

  let chartData = {
    labels: data.map(a => a.formattedDate),
    datasets: [{
      label: 'Greutate',
      data: data.map(a => a.weight),
      tension: 0.4,
    },
      {
        label: 'Talie',
        data: data.map(a => a.waist),
        tension: 0.4,
      }]
  };

  const options = {
    scales: {
      y: {
        offset: true,
        ticks: {count: 5},
      },
      x: {
        offset: true
      },
    },
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        position: 'bottom'
      }
    },
  }

  return <Line
    type={'line'}
    data={chartData}
    options={options}
  />
}

export default MeasurementsChart;
